import { ReloadOutlined } from "@ant-design/icons";
import { formatDate } from "@clipboard-health/date-time";
import { Button, Card, Skeleton, Typography } from "antd";
import { parseISO } from "date-fns";

import { useGetLatestWorkplaceAgreement } from "./api/useGetLatestWorkplaceAgreement";
import { WorkplaceAgreementDownloadButton } from "./WorkplaceAgreementDownloadButton";

const { Text } = Typography;

interface Props {
  workplaceId: string;
}

export function WorkplaceAgreementSection({ workplaceId }: Props) {
  const { latestAgreement, isLoading, isError, refetch } = useGetLatestWorkplaceAgreement(
    workplaceId,
    {
      include: ["document"],
    }
  );

  const acceptedAt = latestAgreement?.attributes.acceptedAt;
  const formattedDate = acceptedAt
    ? formatDate(typeof acceptedAt === "string" ? parseISO(acceptedAt) : acceptedAt)
    : undefined;

  return (
    <Card title="Marketplace Access Agreement">
      {isLoading && <Skeleton active paragraph={{ rows: 1 }} />}
      {!isLoading && isError && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "flex-start" }}>
          <Text type="danger">Failed to load agreement information</Text>
          <Button type="primary" icon={<ReloadOutlined />} onClick={async () => await refetch()}>
            Retry
          </Button>
        </div>
      )}
      {!isLoading && !isError && latestAgreement && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "flex-start" }}>
          <Text>Accepted on {formattedDate}</Text>
          <WorkplaceAgreementDownloadButton workplaceId={workplaceId} />
        </div>
      )}
      {!isLoading && !isError && !latestAgreement && (
        <Text type="secondary">
          This workplace is yet to accept the Terms or has accepted them outside the app
        </Text>
      )}
    </Card>
  );
}
